import { z } from "zod";

import {
  isoDurationRegex,
  rasterIntervalStringServerToDurationObject,
  toISOValue,
} from "@nens/shared-utils";

/* A schema that turns Lizard interval strings into ISO 8601 duration strings and validates them. */

export const isoDurationSchema = z.preprocess(
  (arg) => {
    if (typeof arg === "string") {
      return toISOValue(rasterIntervalStringServerToDurationObject(arg));
    } else {
      return undefined;
    }
  },
  z.string().refine((value) => isoDurationRegex.test(value))
);
